export const lessonFeatures: string[] = [
  "Objectifs d'apprentissage",
  'Focus vocabulaire',
  'Focus grammaire',
  'Guide du professeur',
  'Instruction étape par étape',
  'Pratique guidée',
  'Activité de production orale',
  'Tâches de lecture et écriture',
  'Différenciation',
  'Évaluation',
  'Corrigés inclus',
  'Format PDF prêt à imprimer',
]

export const painPoints: string[] = [
  "Des dimanches soir perdus à chercher des activités, des explications grammaticales et des tâches d'expression orale qui fonctionnent ensemble",
  'Des cours qui se sentent répétitifs — parce que tu reviens toujours aux mêmes exercices que tu connais',
  'Une improvisation visible qui grignote silencieusement ta confiance en toi comme professeur',
  "Pas assez de variété d'une semaine à l'autre — et des élèves qui perdent peu à peu leur motivation sans savoir pourquoi",
  'Des week-ends consacrés à planifier au lieu de te reposer, te ressourcer ou simplement vivre ta vie',
  "Pas de progression claire — juste une collection d'activités déconnectées qui ne deviennent jamais un vrai programme annuel",
]

export const included: string[] = [
  'Volume 1 — Les fondations essentielles',
  'Volume 2 — École, routines, nourriture, loisirs',
  'Volume 3 — Grammaire intermédiaire approfondie',
  'Volume 4 — Expression orale & communication réelle',
  'Volume 5 — Révision, évaluation & consolidation',
  'Volume 6 — Culture, compréhension & projets',
  'Spanish 1 — Programme Annuel Complet',
  'Spanish 2 — Programme Annuel Complet',
  'Bonus 1 — La Grammaire Espagnole Sans Stress',
  'Bonus 2 — 150 Activités de Conversation',
  'Bonus 3 — Pack Complet d’Évaluations & Corrigés',
  'Bonus 4 — 40 Leçons de Culture Hispanophone',
  'Bonus 5 — 50 Cours d’Urgence Prêts à l’Emploi',
  'Garantie satisfait ou remboursé 7 jours',
  'Accès immédiat',
  'Format PDF — prêt à utiliser',
]
